import { h, } from "@stencil/core";
import { isBreakpointEqualOrSmaller } from "../../../utils/functions/breakPointChecker";
import { setScrollLock } from "../../../utils/functions/scrollLock";
import { FocusTrapHelper } from "../../../utils/functions/focusTrapHelper";
export class DcUiHeaderUserMenu {
    constructor() {
        this.isMobile = false;
        this.isOpen = false;
        this.updateIsMobile = () => {
            this.isMobile = isBreakpointEqualOrSmaller('md');
        };
        this.iconClickHandler = () => {
            this.dcFlyoutClose.emit(this.el);
            this.close();
        };
    }
    onOutsideClick(e) {
        if (!this.isOpen)
            return;
        // Get the full path of elements including through shadow DOM boundaries
        const path = e.composedPath();
        // Check if our element is in the path
        if (!path.includes(this.el) && this.isOpen) {
            this.close();
        }
    }
    onKeyDown(e) {
        if (!this.isOpen)
            return;
        if (e.key === 'Escape') {
            this.close();
        }
    }
    // method to open the modal
    async open() {
        setScrollLock(true);
        this.dialog.show();
        setTimeout(() => {
            this.isOpen = true;
        }, 100);
        this.focusTrapHelper.activateFocusTrap();
    }
    // method to close the modal
    async close() {
        if (!this.isMobile) {
            setScrollLock(false);
        }
        this.dialog.close();
        setTimeout(() => {
            this.isOpen = false;
        }, 100);
        this.focusTrapHelper.deactivateFocusTrap();
    }
    async toggle() {
        if (this.dialog.open) {
            this.close();
        }
        else {
            this.open();
        }
    }
    componentDidLoad() {
        this.updateIsMobile();
        window.addEventListener('resize', this.updateIsMobile);
        this.focusTrapHelper = new FocusTrapHelper(this.el);
    }
    disconnectedCallback() {
        window.removeEventListener('resize', this.updateIsMobile);
    }
    render() {
        const backButton = (h("button", { key: '4a35716269fa4dee216ba14158b77206ba834baf', class: "back-button", onClick: this.iconClickHandler }, h("dc-ui-icon", { key: 'f82507b9ad08ad1aacc33d3c435772e4668882c5', size: "tiny", name: "dc_backward_left" }), this.backButtonLabel));
        const closeButton = (h("dc-ui-button", { key: '6239f5951877f36e3f787efd854f57d5732a7fd5', variant: "link", icon: "dc_close", hideLabel: true, id: "close-icon", size: "small", onClick: this.iconClickHandler }, "Close Modal"));
        return (h("dialog", { key: 'f29a01d058e16418dbc93b12a556f2ed18ec906d', class: "user-menu-dialog", ref: (el) => (this.dialog = el) }, h("div", { key: '3c6ab9a8592230de7dba36a24c22c72b68667d79', class: "dialog-body" }, h("div", { key: '8113cb05f7fbbe34387e4b0614ec3679727c4e86', class: "dialog-content" }, h("div", { key: '8ea69a1abb51ba0a80d9b90257833837d38972bf', class: "title-wrapper" }, this.headline && (h("dc-ui-text", { key: 'aad66399c4b16f703d2b53379f7e2b7fab2283e9', variant: "h4", color: "darkBlue02" }, this.headline)), h("slot", { key: '48c4a6d52329d9c6069ac3b73221a35fac6292ad', name: "title" })), h("div", { key: '981947af5fd07bed5f0a726453c6d64fa6ba9041', class: "content-wrapper" }, h("slot", { key: '4b21bff54d2db2708f451782facf6c89e152d328', name: "content" })), h("div", { key: '7942a1dc16b2fe363c653c129d1c90944f4b7ac8', class: "cta-wrapper" }, h("slot", { key: '8487a95c366ddd57252762e9720f00e06a9756c1', name: "cta" })), this.isMobile ? (this.backButtonLabel ? backButton : closeButton) : closeButton))));
    }
    static get is() { return "dc-ui-header-user-menu"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["dc-ui-header-user-menu.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dc-ui-header-user-menu.css"]
        };
    }
    static get properties() {
        return {
            "headline": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "headline",
                "reflect": false
            },
            "backButtonLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "back-button-label",
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "isMobile": {}
        };
    }
    static get events() {
        return [{
                "method": "dcFlyoutClose",
                "name": "dcFlyoutClose",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "HTMLDcUiHeaderUserMenuElement",
                    "resolved": "HTMLDcUiHeaderUserMenuElement",
                    "references": {
                        "HTMLDcUiHeaderUserMenuElement": {
                            "location": "global",
                            "id": "global::HTMLDcUiHeaderUserMenuElement"
                        }
                    }
                }
            }];
    }
    static get methods() {
        return {
            "open": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            },
            "close": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            },
            "toggle": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "click",
                "method": "onOutsideClick",
                "target": "window",
                "capture": false,
                "passive": false
            }, {
                "name": "keydown",
                "method": "onKeyDown",
                "target": "window",
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=dc-ui-header-user-menu.js.map
